import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listFilter'
})
export class ListFilterPipe implements PipeTransform {
  // https://blog.officekoma.co.jp/2019/01/angular-template.html
  /**
   * items:item[] から item のプロパティ値でフィルターをかける。
   * ex. items: vaccineEvent[], col: 'touyoHouhou', value: '筋注', addUndefined: true の場合
   * '筋注' に、item['touyoHouhou'] が含まれている場合、配列に入れて返す。
   * item に 'touyoHouhou' がない場合も配列に入れて返す。(addUndefined: trueのため)
   * @param items item 配列 ex. vaccineEvent[]
   * @param col item のプロパティ名 ex. 'touyoHouhou'
   * @param value フィルター値 ex. '筋注'
   * @param addUndefined item.col が undefined の item も含めて返すか。
   *                     true の場合 item.col が undefined でも配列に含めて返す。
   */
  transform(items: any[], col: string, value: any, addUndefined: boolean): any[] {
    // console.log(value,items,col);
    if (!items) {
      return [];
    }
    // valueがnull,undefinedの場合、colが空の場合何もせず返す
    if (col.length === 0 || typeof value === 'undefined' || value === null) {
      return items;
    }
    // addUndefined = true :x[col]がundefinedも含めて返す
    // valueが配列の場合、x[col]がvalueの中にあれば返す
    if (addUndefined) {
      return items.filter(x => {
        if (value.length) {
          return typeof x[col] === 'undefined' || value.includes(x[col]);
        }
        return typeof x[col] === 'undefined' || x[col] === value;
      });
    }
    // x[col] = value のものだけ返す
    // addUndefined = false :x[col]がundefined、空文字('')は含めない
    return items.filter(x => {
      if (value.length) {
        return x[col] !== '' && value.includes(x[col]);
      }
      return x[col] === value;
    });
  }
}
